// Tag the message with where it came from. Never overwrite a restored form or send it automatically.
const enquiryTypes = {
  delivery: 'Delivery date or destination',
  gift: 'Online gift order',
  wholesale: 'Wholesale cards and gifts',
  location: 'Location suggestion',
};

export function contactContext(search) {
  const params = new URLSearchParams(search);
  const clean = (value) => (value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim();
  return {
    enquiry: enquiryTypes[params.get('enquiry')] || '',
    product: [clean(params.get('product')), clean(params.get('selection'))].filter(Boolean).join(' · ').slice(0, 500),
  };
}

function initialiseContactForms(root = document) {
  const context = contactContext(window.location.search);
  root.querySelectorAll('.cp-contact-form').forEach((form) => {
    if (form.dataset.contextReady) return;
    form.dataset.contextReady = 'true';
    const message = form.elements.namedItem('contact[body]');
    const enquiry = form.elements.namedItem('contact[enquiry_type]');
    const product = form.elements.namedItem('contact[product]');
    if (!message?.value && context.enquiry && enquiry?.value === 'General') enquiry.value = context.enquiry;
    if (product && !product.value && context.product) product.value = context.product;
    // Show the product the message will mention, so nothing is sent that the customer cannot see.
    const about = form.querySelector('[data-contact-about]');
    const aboutText = about?.querySelector('[data-contact-about-text]');
    if (about && aboutText && product?.value) {
      aboutText.textContent = product.value;
      about.hidden = false;
    }
  });
}

initialiseContactForms();
document.addEventListener('shopify:section:load', (event) => initialiseContactForms(event.target));
